import React from 'react'
import Modal from 'react-modal'
import DocketColumnForm from '../Forms/DocketColumnForm';
import { setLocal } from '../../utils/localStorage';
import { DOCKET_LIST_COLUMNS } from '../../config';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        maxWidth: '800px',
        minWidth: '320px',
        maxHeight: '90vh',
        padding: '0',
        borderRadius: '12px',
        border: 'none',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)',
        overflow: 'hidden',
    },
    overlay: { 
        zIndex: 1000,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        backdropFilter: 'blur(4px)',
    }
};
export default function DocketFilterColumnsModal({ modal, setModal, visibleCols, setVisibleCols }) {

    const handleSubmit = async (values) => {
        setVisibleCols(values)
        setLocal(DOCKET_LIST_COLUMNS, JSON.stringify(values))
        setModal(false)
    }
    return (
        <Modal
            isOpen={modal}
            onRequestClose={() => setModal(false)}
            style={customStyles}
            contentLabel="Column Visibility Modal"
            ariaHideApp={false}
            shouldCloseOnOverlayClick={true}
            shouldCloseOnEsc={true}
        >
            <div className="modal-container" style={{ 
                display: 'flex', 
                flexDirection: 'column', 
                height: '100%',
                backgroundColor: '#fff'
            }}>
                {/* Modal Header */}
                <div className="modal-header" style={{
                    padding: '20px 24px',
                    borderBottom: '1px solid #e9ecef',
                    backgroundColor: '#f8f9fa',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    minHeight: '70px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{
                            width: '40px',
                            height: '40px',
                            borderRadius: '8px',
                            backgroundColor: '#28a745',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: '12px'
                        }}>
                            <span className="material-icons-sharp" style={{ color: 'white', fontSize: '20px' }}>
                                view_column
                            </span>
                        </div>
                        <div>
                            <h4 className="modal-title mb-0" style={{
                                color: '#212529',
                                fontWeight: '600',
                                fontSize: '1.25rem',
                                lineHeight: '1.2'
                            }}>
                                Column Visibility
                            </h4>
                            <p className="mb-0" style={{
                                color: '#6c757d',
                                fontSize: '0.875rem',
                                marginTop: '2px'
                            }}>
                                Customize which columns to show or hide in the table
                            </p>
                        </div>
                    </div>
                    <button 
                        type="button" 
                        className="btn-close" 
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '1.5rem',
                            cursor: 'pointer',
                            padding: '8px',
                            borderRadius: '6px',
                            transition: 'background-color 0.2s ease'
                        }}
                        onClick={() => setModal(false)}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                        onMouseOut={(e) => e.target.style.backgroundColor = 'transparent'}
                        aria-label="Close column visibility modal"
                    >
                        <span className="material-icons-sharp">close</span>
                    </button>
                </div>

                {/* Modal Body */}
                <div className="modal-body" style={{ 
                    padding: '24px',
                    flex: '1',
                    overflowY: 'auto',
                    backgroundColor: '#fff'
                }}>
                    <DocketColumnForm
                        isLoading={false}
                        handleSubmit={handleSubmit}
                        setModal={setModal}
                        visibleCols={visibleCols} 
                        setVisibleCols={setVisibleCols}
                    />
                </div>
            </div>
        </Modal>
    )
}
